export const getDependenciesFor = (segement, config) => {
    return config.dependencies[segement];
};

export const getPossibleAttributesFor = (segment, config, selected) => {
    const dependenciesToCheck = getDependenciesFor(segment, config);

    if (dependenciesToCheck) {
        const itemToMatchDependencies = config.items.filter(item => {
            const matches = dependenciesToCheck.reduce((count, dep) => {
                const selectedItem = selected[dep];
                const currentItem = item[dep];

                if (selectedItem === currentItem) return count + 1;

                return count;
            }, 0);

            return matches === dependenciesToCheck.length;
        });

        return itemToMatchDependencies.reduce((prev, curr) => {
            const segmentForItem = curr[segment];

            if (!segmentForItem) return prev;

            return {
                ...prev,
                [segmentForItem]: config[segment][segmentForItem],
            };
        }, {});
    }

    return {};
};

export const getImpossibleAttributesFor = (segment, config, selected) => {
    const possibleAttributes = getPossibleAttributesFor(
        segment,
        config,
        selected
    );

    return Object.keys(config[segment]).reduce((prev, key) => {
        if (possibleAttributes[key]) return prev;

        return {
            ...prev,
            [key]: config[segment][key],
        };
    }, {});
};

export const getProductImages = (config, selected) => {
    const { productImageComposition, items } = config;
    return Object.keys(productImageComposition).map(key => {
        const fieldsToCompare = productImageComposition[key];
        const item =
            items.find(item => {
                let found = 0;
                fieldsToCompare.forEach(field => {
                    if (item[field] === selected[field]) {
                        found = found + 1;
                    }
                });
                return found === fieldsToCompare.length;
            }) || {};

        return item.imageSrc;
    });
};

export const getPossibilitiesFor = (needle = {}, config, selected = {}) => {
    const needleKey = Object.keys(needle)[0];

    const deps = config.dependencies[needleKey];

    const filtered = config.items
        .filter(item => {
            return item[needleKey] === needle[needleKey];
        })
        .map(item => {
            let weight = 0;

            deps.forEach((dep, i) => {
                if (item[dep] === selected[dep]) {
                    weight = weight + 1 + deps.length - i;
                }
            });

            return {
                ...item,
                weight,
            };
        })
        .slice()
        .sort((a, b) => a.weight < b.weight)
        .map(item => {
            delete item.weight;
            return item;
        });

    return {
        ...selected,
        ...(filtered[0] || {}),
    };
};

export const mapSelectedVariationToProperties = (selectedVariation, config) =>
    Object.keys(selectedVariation).reduce((acc, key) => {
        const segment = config.segments.find(s => s.name === key);
        const valueKey = selectedVariation[key];

        if (!segment) return acc;
        const value = config[segment.name][valueKey].title;

        return {
            ...acc,
            [segment.title]: value,
        };
    }, {});

export const mapPropertiesToSelectedVariation = (properties, config) =>
    Object.keys(properties).reduce((acc, key) => {
        const segment = config.segments.find(s => s.title === key);
        const value = properties[key];

        if (!segment) return acc;

        const configItem = config[segment.name];

        if (!configItem) return acc;

        const keys = Object.keys(configItem).filter(
            key => configItem[key].title === value
        );

        return {
            ...acc,
            [segment.name]: keys[0],
        };
    }, {});



// WEBPACK FOOTER //
// ./src/utils/configUtils.js